import React from "react";
import { Box, Typography, Breadcrumbs, Link } from "@mui/material";
import FeaturedTraining from "./FeaturedTraining";
import TutorialVideos from "./TutorialVideos";
import QuickStartGuides from "./QuickStartGuides";

function Training() {
  return (
    <Box
      sx={{
        pt: "92px",
        px: { xs: 2, md: 4 },
        pb: 4,
        backgroundColor: "#f9fdff",
        minHeight: "100vh",
        maxWidth: "1366px",
        mx: "auto",
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs separator="/" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" sx={{ fontSize: "12px" }}>
            RepAssist
          </Link>
          <Typography sx={{ fontSize: "12px", color: "#666" }}>
            Training & Resources
          </Typography>
        </Breadcrumbs>

        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: "#202020", mb: 0.5 }}
        >
          Training & Resources
        </Typography>

        <Typography sx={{ fontSize: "14px", color: "#666666" }}>
          Learn how to get the most out of RepAssist
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <FeaturedTraining />
        <TutorialVideos />
        <QuickStartGuides />
      </Box>
    </Box>
  );
}

export default Training;
